exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_VideoMainDiv_2QzexVXhzZvwBc-Pil1Pzc {\n  width: 100%;\n  height: 100%;\n  background-color: black;\n}\n\n.IA_VideoMainDiv_2QzexVXhzZvwBc-Pil1Pzc iframe {\n  margin: 0 !important;\n}", ""]);

// Exports
exports.locals = {
	"IA_VideoMainDiv": "IA_VideoMainDiv_2QzexVXhzZvwBc-Pil1Pzc"
};